// anesid - Step 1: import the createAsyncThunk
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import {
  getUsers,
  deleteUser,
  deleteUsers,
  updateUser,
} from 'src/services/users';

const initialState = { users: [], notification: null };

const slice = createSlice({
  name: 'user',
  notification: null,
  initialState,
  reducers: {
    getAllUsers(state, action) {
      state.users = action.payload;
    },

    addUserToList(state, action) {
      state.users.unshift(action.payload);
    },

    removeUserFromList(state, action) {
      const id = action.payload;
      state.users = state.users.filter((user) => user.id !== id);
    },

    removeUsersFromList(state, action) {
      const ids = action.payload;
      state.users = state.users.filter((user) => !ids.includes(user.id));
    },
    showNotification(state, action) {
      console.log('action = ', action);
      state.notification = {
        status: action.payload.status,
        message: action.payload.message,
      };
    },
    updateUserInList(state, action) {
      const userIndex = state.users.findIndex(
        (user) => user.id === action.payload.id
      );
      state.users[userIndex] = action.payload;
    },
    // anesid - Step 3: Add extra reducers here e.g. reponse from Thunks like: getUserList
    extraReducers: (builder) => {
      builder.addCase(getUserList.fulfilled, (state, action) => {
        // Add user to the state array
        state.users = action.payload;
      });
    },
  },
});

export const reducer = slice.reducer;

export const userActions = slice.actions;

// anesid - Step 2: Create the thunk function that performs the async API call through function: getUserList
// export const getUserList = createAsyncThunk(
//   'users/fetchByIdStatus',
//   async () => {
//     console.log('The api call will be initiated');
//     const response = await getUsers();
//     console.log('Response from API', response.data);
//     return response.data;
//   }
// );

export const getUserList = () => {
  return async (dispatch) => {
    try {
      const response = await getUsers();
      dispatch(slice.actions.getAllUsers(response.data));
    } catch (error) {
      console.log('error = ', error);
    }
  };
};

// export const getUserList = () => async (dispatch) => {
//   const response = await getUsers();

//   if (response) {
//     dispatch(slice.actions.getAllUsers(response.data));
//   }
// };

export const removeUser = (id) => {
  return async (dispatch) => {
    try {
      await deleteUser(id);
      dispatch(slice.actions.removeUserFromList(id));
    } catch (error) {
      console.log(error);
    }
  };
};

export const removeUsers = (ids) => {
  return async (dispatch) => {
    try {
      const requestedIDs = ids.join('&userIDs=');
      await deleteUsers(requestedIDs);
      dispatch(slice.actions.removeUsersFromList(ids));
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateUserInfo = (user) => {
  return async (dispatch) => {
    try {
      await updateUser(user);
      // dispatch(
      //   slice.actions.showNotification({
      //     status: 'success',
      //     message: 'Profile was updated successfully',
      //   })
      // );
      dispatch(slice.actions.updateUserInList(user));
    } catch (error) {
      console.log(error);
      // dispatch(
      //   slice.actions.showNotification({
      //     status: 'error',
      //     message: 'Sending cart data failed!',
      //   })
      // );
    }
  };
};

export default slice;
